import { render, staticRenderFns } from "./AiSuggestionIdeaParser.vue?vue&type=template&id=0d8a1c4a"
import script from "./AiSuggestionIdeaParser.vue?vue&type=script&lang=js"
export * from "./AiSuggestionIdeaParser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports